import type { GeoChartColumn, GeoData } from '../types';
import { DEFAULT_COLUMN_WIDTH, DEPTH_COLUMN_WIDTH } from '../base';
import { DepthGeoChartBodyColumn } from '../BodyColumns/DepthGeoChartBodyColumn';
import { StratigraphyGeoChartBodyColumn } from '../BodyColumns/StratigraphyGeoChartBodyColumn';
import { StratumGeoChartBodyColumn } from '../BodyColumns/StratumGeoChartBodyColumn';

export const getColumns: () => GeoChartColumn[] = () => {
    return [
        {
            key: 'system',
            name: 'Система',
            width: DEFAULT_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn, geoData: GeoData) => {
                return <StratigraphyGeoChartBodyColumn accessor="Система" column={column} geoData={geoData} />;
            },
        },
        {
            key: 'division',
            name: 'Отдел',
            width: DEFAULT_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn, geoData: GeoData) => {
                return <StratigraphyGeoChartBodyColumn accessor="Отдел" column={column} geoData={geoData} />;
            },
        },

        {
            key: 'layer',
            name: 'Ярус',
            width: DEFAULT_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn, geoData: GeoData) => {
                return <StratigraphyGeoChartBodyColumn accessor="Ярус" column={column} geoData={geoData} />;
            },
        },
        {
            key: 'horizon',
            name: 'Горизонт',
            width: DEFAULT_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn, geoData: GeoData) => {
                return <StratigraphyGeoChartBodyColumn accessor="Горизонт" column={column} geoData={geoData} />;
            },
        },

        {
            key: 'stratum',
            name: 'Пласт',
            width: DEFAULT_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn, geoData: GeoData) => {
                return <StratumGeoChartBodyColumn column={column} geoData={geoData} />;
            },
        },
        {
            key: 'depth',
            name: 'Абс. отм. (м)',
            width: DEPTH_COLUMN_WIDTH,
            renderBody: (column: GeoChartColumn) => {
                return <DepthGeoChartBodyColumn column={column} />;
            },
        },
    ];
};
